import $ from 'jquery';
import 'select2';
import '../components/words/intro';
import '../components/gravityforms';
import '../components/menu';
import '../components/sliders/hero';
import '../../sass/default.scss';
